import { FIELD_SIZES } from '../../constants';

export function normalizeFieldSize(size) {
  return FIELD_SIZES.includes(size) ? size : 'md';
}

export function buildInputClasses({ size, error, className, extra = [] }) {
  const normalizedSize = normalizeFieldSize(size);
  return [
    'input-control',
    `input-${normalizedSize}`,
    error ? 'input-error' : '',
    ...extra,
    className
  ].filter(Boolean).join(' ');
}

export function buildTextAreaClasses({ size, error, className }) {
  const normalizedSize = normalizeFieldSize(size);
  return [
    'input-control',
    'textarea-control',
    `textarea-${normalizedSize}`,
    error ? 'input-error' : '',
    className
  ].filter(Boolean).join(' ');
}

export function FieldMessage({ errorMessage, helperText, id }) {
  if (errorMessage) {
    return (
      <p id={id} className="mt-1.5 text-sm text-red-600" role="alert">
        {errorMessage}
      </p>
    );
  }

  if (helperText) {
    return (
      <p id={id} className="mt-1.5 text-sm text-gray-500">
        {helperText}
      </p>
    );
  }

  return null;
}
